module.exports = __webpack_public_path__ + "img/arrow-top-right.00985ea8.svg";